//// WARNING: This file is auto-generated. Do not modify here
import { z } from "zod";
import { DocumentReference } from "@atgof-firebase/types";
export const episodeSchema = z.object({
  pendingActionsForScenes: z
    .array(
      z.custom<DocumentReference>(
        (val) =>
          val &&
          typeof val === "object" &&
          "id" in val &&
          "firestore" in val &&
          "path" in val,
      ),
    )
    .optional(),
  txDate: z.date().optional(),
  director: z.string().optional(),
  displayName: z.string(),
  cast: z.array(z.string()).default([]),
  isDropped: z.boolean().optional(),
  hasScripts: z.boolean().default(false),
  writer: z.string().optional(),
  sceneCount: z.number().default(0),
  nonCast: z.object({ sa: z.array(z.string()) }).optional(),
  sets: z.array(z.string()).default([]),
  isComplete: z.boolean().optional(),
});
export type Episode = z.infer<typeof episodeSchema>;
